import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
  const token = useSelector((state) => state.auth.token);

  if (token) {
    /* uncomment below line when dashboard is added in admin panel */
    // return <Navigate to="/dashboard" replace />;
    return <Navigate to="/users" replace />;
  }

  return children;
};

export default PublicRoute;
